import '../text-and-lang/as-text.ts';
import '../inputs/buttons/as-text-button.ts';
import { useShadow, useShadowStyle } from "../../util/wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalSaveProject extends HTMLElement {
  static readonly tag = 'as-modal-save-project' as const;

  private _nameInput: HTMLInputElement | null = null;

  get html() {
    return /*html*/`
      <div id="save-project-panel" class="panel-content">
        <as-text class="modal-title" dict-key="modals.project.save.title" default-text="Save project"></as-text>
        <as-text class="modal-desc" dict-key="modals.project.save.description" default-text="Give your project a name. It will also be used as the filename when downloading."></as-text>
        <div class="input-field">
          <label class="input-label"><as-text dict-key="modals.project.save.name-label">Project name</as-text></label>
          <input id="project-name-input" type="text" class="project-name-input" placeholder="e.g. My design">
        </div>
        <div class="row option-buttons">
          <as-text-button name="cancel-save-project" dict-key="modals.project.save.cancel">Cancel</as-text-button>
          <as-text-button name="confirm-save-project" dict-key="modals.project.save.confirm">Save</as-text-button>
        </div>
      </div>
    `
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
    this._nameInput = this.shadowRoot?.querySelector('#project-name-input') ?? null;
  }

  getValue(): string {
    return this._nameInput?.value ?? '';
  }

  setValue(value: string): void {
    if (this._nameInput) this._nameInput.value = value;
  }

  reset(): void {
    this.setValue('');
  }

  focusInput(): void {
    this._nameInput?.focus();
    this._nameInput?.select();
  }
}

customElements.define(AsModalSaveProject.tag, AsModalSaveProject)
